/*
  desktop_searchbar
*/
/**
 * Desktop Search Bar Management
 */

/************************************************
		EVENT MANAGEMENT
*************************************************/
var desk_header_in_class = "header.desk_hdr_in";
var desk_searchbar_class = desk_header_in_class + " .search-bar-wrapper input.search-bar";

$(document.body).on("change keyup", desk_searchbar_class, function() {
  //== get input
  var _el = $(this);

  //== get desk header in element
  var _header = $(desk_header_in_class);

  //== get its value
  var _el_value = _el.val();

  if ($.trim(_el_value).length !== 0) {
    if (!_header.hasClass("search-bar-active")) {
      _header.addClass("search-bar-active");
    }
  }
  else {
    _header.removeClass("search-bar-active");
  }
});
